module.exports = __webpack_public_path__ + "static/media/excel-file.7962e979.svg";